import { call, put, takeEvery } from "redux-saga/effects";
import Constants from "../../Action/Constants";
import { ActionInterface } from "../../Interface/ActionInterface";
import { ErrorHandlerSequence } from "../Sequences/ErrorHandlerSequence";
import Http from "../../Http/Http";


export default function* dataTypesList(action: ActionInterface): any {
  try {
    const res = yield call(Http.get, "data-labels");
    yield put({
      type: Constants.GLOBAL_RECEIVE_DATA_TYPES_LIST_SUCCESS,
      payload: res.data
    });

  } catch (err) {
    // should signout user if entity could not be loaded
    yield put({
      type: Constants.PAGE_SIGNOUT_START
    });
    
    yield ErrorHandlerSequence(err, action);
  }
}

export function* watchDataTypesList() {
  yield takeEvery(Constants.GLOBAL_RECEIVE_DATA_TYPES_LIST, dataTypesList);
}
